module.exports = __webpack_public_path__ + "img/premiseIcon4.5b2595c3.png";